import React from "react";
import { Row, Col } from "antd";

const PageLayout = ({
  left,
  right,
  leftWidth = 50,
  rightWidth = 50,
  gutter = 16,
}) => {
  const total = leftWidth + rightWidth;

  const leftSpan = Math.round((leftWidth / total) * 24);
  const rightSpan = 24 - leftSpan;

  return (
    <Row gutter={gutter} style={{ minHeight: "100%" }}>
      <Col xs={24} md={leftSpan} style={{ marginBottom: "16px" }}>
        {left}
      </Col>

      <Col xs={24} md={rightSpan}>
        <div
          style={{
            position: "sticky",
            top: 170,
            height: "calc(100vh - 32px)",
            overflowY: "auto",
          }}
        >
          {right}
        </div>
      </Col>
    </Row>
  );
};

export default PageLayout;